import * as React from 'react';
import styled from 'styled-components';

const StyledEmptyTable = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
`;

const StyledIcon = styled.div`
  svg path {
    fill: #f2f2ed;
  }
`;

const StyledText = styled.p`
  color: ${({ theme }) => theme.colors.font1};
  margin: 0;
  user-select: none;
`;

const StyledTitle = styled(StyledText)`
  font-size: 24px;
  padding: 2vh 0;
`;

const StyledDescription = styled(StyledText)`
  font-size: 14px;
  text-align: center;
  padding: 0;
`;

export interface IEmptyTableProps {
  icon?: React.ReactNode;
  title: string;
  description: string | React.ReactNode;
}

const EmptyTable: React.FunctionComponent<IEmptyTableProps> = props => {
  const { icon, title, description } = props;
  return (
    <StyledEmptyTable>
      <StyledIcon>{icon}</StyledIcon>
      <StyledTitle>{title}</StyledTitle>
      <StyledDescription>{description}</StyledDescription>
    </StyledEmptyTable>
  );
};

export default EmptyTable;
